import React, { useState, useEffect } from "react";
import { addRecord, getAllConfigureProducts , updateRecord } from "../../../Services/DataServices";
import GenericTable from "./GenericTable";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../Components/Common/Loader";
import AddModal from "../../Forms/AddModal";
import EditRecordModal from "../../Forms/EditableModal";

const ConfigureProductDataCount = ({
    totalItems,
    setTotalItems,
    isAddModalOpen,
    setAddModalOpen,
    closeModal,
    newRecord,
    setNewRecord,
    searchQuery,
}) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
      const [isEditModalOpen, setIsEditModalOpen] = useState(false);
      const [selectedItem, setSelectedItem] = useState(null);
    
    const limit = 50;

    const fetchData = async (page = 1, searchQuery = "") => {
        setLoading(true);
        setData([]);
        try {
            const filters = { searchQuery };
            const response = await getAllConfigureProducts(page, limit, filters);
            // console.log("API Response:", response);
            if (response.status && response.result) {
                setData(response?.result?.data);
                setTotalItems(response.result.pagination?.totalRecords || 0);
                setTotalPages(response.result.pagination?.totalPages || 1);
                setPage(response.result.pagination?.currentPage || 1);
            } else {
                toast.error("Failed to fetch data");
                setData([]);
                setTotalItems(0);
                setTotalPages(1);
                setPage(1);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Error fetching data.");
            setData([]);
            setTotalItems(0);
            setTotalPages(1);
            setPage(1);
        } finally {
            setTimeout(() => setLoading(false), 100);
        }
    };
    useEffect(() => {
        fetchData(page, searchQuery);
    }, [page, searchQuery]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const handleNewRecordChange = (event) => {
        let value = event.target.value;
        if (event.target.name === 'ProductUniqueName') {
          value = value.toLowerCase();
        }
        setNewRecord({
          ...newRecord,
          [event.target.name]: value,
        });
      };
      const handleEdit = (item) => {
        setSelectedItem(item);
        setIsEditModalOpen(true);
      };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

      const handleSubmit = async (data) => {
        // console.log("data",data);
          try {
            const response = await addRecord(data);
            // console.log("response",response);        
            if (!response.response === false ) {
              closeModal();
              toast.success('Record Added successfully!')
            }else{
              closeModal();
                toast.error(response.message)
            }
          } catch (err) {
            toast.error("Failed to upload file.");
          } finally {
            setLoading(false);
            fetchData(page)
            setAddModalOpen(false);
          }
        };

        const handleUpdate = async (event) => {
            event.preventDefault();
            console.log("Updating with data:", selectedItem);
            try {
              const response = await updateRecord(selectedItem);
              if (response.status && response.result) {
                setData((prevData) => {
                  const updatedData = prevData.map((item) =>
                    item._id === response.result.result._id ? response.result.result : item
                  );
                  toast.success("Record Updated successfully!");
                  return updatedData;
                });
                closeEditModal();
              } else {
                toast.error(response.message || "Error updating user!");
              }
            } catch (error) {
              toast.error("Error updating user!");
              console.error("Error updating user:", error);
            }
          };

    const columnList = [
        // {
        //     label: "no",
        //     cell: (row, index) => index + 1,
        // },
        { label: "Product UniqueName", field: "name", cell: (row) => <span>{row.name || "-"}</span> },
        { label: "Product Group", field: "productGroup", cell: (row) => <span>{row.productGroup || "-"}</span> },
        { label: "CAS No", field: "casNo", cell: (row) => <span>{row.casNo || "-"}</span> },
        { label: "Part", field: "part", cell: (row) => <span>{row.part || "-"}</span> },
        { label: "Main ATC Category", field: "mainAtcCategory", cell: (row) => <span>{row.mainAtcCategory || "-"}</span> },
        { label: "SubCategory 1", field: "subCategory1", cell: (row) => <span>{row.subCategory1 || "-"}</span> },
        { label: "SubCategory 2", field: "subCategory2", cell: (row) => <span>{row.subCategory2 || "-"}</span> },
        { label: "SubCategory 3", field: "subCategory3", cell: (row) => <span>{row.subCategory3 || "-"}</span> },
    ];

    return (
        <div>
            {loading ?
                <Loader />
                :
                <GenericTable
                    columnList={columnList}
                    data={data}
                    totalPages={totalPages}
                    totalItems={totalItems}
                    handlePageChange={handlePageChange}
                    currentPage={page}
                    handleEdit={handleEdit}
                />
            }
            <AddModal
             isOpen={isAddModalOpen}
            toggleModal={closeModal}
             modalTitle="Add Record"
             btnLabel="Add Record"
             handleChange={handleNewRecordChange}
            fieldData={newRecord}
            handleSubmit={handleSubmit}
            />
            <EditRecordModal
            isEditModalOpen={isEditModalOpen}
             selectedItem={ selectedItem}
             setSelectedItem={setSelectedItem}
             closeEditModal={closeEditModal}
             columnList={columnList}
             handleUpdate={handleUpdate}
            />
        </div>
    );
};

export default ConfigureProductDataCount;
